export enum AuthenticationLevelMode {
  None = 'None',
  Invalid = 'Invalid',
  Optional = 'Optional',
  RequiredToConfirm = 'RequiredToConfirm',
  Confirmed = 'Confirmed',
  ConfirmedDeprecated = 'ConfirmedDeprecated',
}

export enum IdentityMode {
  None = 'None',
  Unconfirmed = 'Unconfirmed',
  Confirmed = 'Confirmed',
  Deprecated = 'Deprecated',
}

export enum AuthenticationProviderType {
  Email = 'Email',
  Phone = 'Phone',
  AppTotp = 'AppTotp',
}

export class PasswordRequirementsInfo {
  constructor(
    public readonly minLength: number,
    public readonly maxLength: number,
    public readonly lower: boolean,
    public readonly upper: boolean,
    public readonly digit: boolean,
    public readonly symbol: boolean
  ) {}
}

export class LoginInfo {
  constructor(
    public readonly isAnonymous: boolean,
    public readonly userName: string,
    public readonly issued: Date,
    public readonly expires: Date,
    public readonly userId?: string,
    public readonly name?: string,
    public readonly displayName?: string,
    public readonly isAdmin?: boolean,
    public readonly needsPasswordChange?: boolean,
    public readonly emailAddress?: string,
    public readonly secondFactorMode?: AuthenticationLevelMode,
    public readonly emailIdentityMode?: IdentityMode,
    public readonly phoneIdentityMode?: IdentityMode,
    public readonly appTotpIdentityMode?: IdentityMode,
    public readonly passwordRequirements?: PasswordRequirementsInfo
  ) {
    if (!this.displayName) {
      if (this.name) {
        this.displayName = this.name;
      } else {
        this.displayName = this.isAnonymous ? '<Anonym>' : this.userName;
      }
    }
  }
}
